import wordingList from './wording-list.json'
import _ from 'lodash'

export const wrapWordingToTextJustify = (message, className, options) => {
  const replaces = _.get(options, 'replaces', wordingList)
  const _className = className || 'group-wording'
  const conditions = new RegExp(replaces.join('|'), 'gi')
  return message.replace(conditions, (wording) => `<span class='${_className}'>${wording}</span>`)
}
